import { redirect } from 'react-router-dom';
import { APP_AUTH } from '../services/constants/AppConstant';
import {
  LOGIN,
  CUSTOMER_LOGIN,
  CUSTOMER_DASHBOARD,
  ADMIN_DASHBOARD,
} from '../services/constants/URIConstants';

/**
 * Get user role from cookies
 */
const getUserRole = (): string | null => {
  const cookiesList = document.cookie.split(';');
  for (let i = 0; i < cookiesList.length; i++) {
    const cookie = cookiesList[i].trim();
    const item = cookie.split('=');
    if (item[0] === 'user_role') {
      return item[1] || null;
    }
  }
  return null;
};

/**
 * Get auth token from cookies
 */
const getAuthToken = (): string | null => {
  const cookiesList = document.cookie.split(';');
  for (let i = 0; i < cookiesList.length; i++) {
    const cookie = cookiesList[i].trim();
    const item = cookie.split('=');
    const key = item[0].replace(' ', '');
    if (key === APP_AUTH.COOKIE_TOKEN_KEY) {
      return item[1] || null;
    }
  }
  return null;
};

/**
 * @description Guard function to check whether user has access to the route or not
 *
 * @param {String} param
 * @returns {Function}
 */
const protectedLoader = ({ request = {} }) => {
  const applicationCookie = getAuthToken();
  if (!applicationCookie) {
    return redirect(LOGIN);
  }
  return null;
};

/**
 * @description Guard function for admin routes - only allows admin access
 */
const adminProtectedLoader = ({ request = {} }) => {
  const applicationCookie = getAuthToken();
  const userRole = getUserRole();
  
  if (!applicationCookie) {
    return redirect(LOGIN);
  }
  
  if (userRole === 'CUSTOMER') {
    return redirect(CUSTOMER_DASHBOARD);
  }

  if (userRole === null || (userRole !== 'CUSTOMER' && userRole !== 'PARTNER')) {
    return null;
  }
  
  return redirect(LOGIN);
};

/**
 * @description Guard function for customer routes - only allows customer access
 */
const customerProtectedLoader = ({ request = {} }) => {
  const applicationCookie = getAuthToken();
  const userRole = getUserRole();
  
  if (!applicationCookie) {
    return redirect(CUSTOMER_LOGIN);
  }
  
  if (userRole !== 'CUSTOMER') {
    return redirect(ADMIN_DASHBOARD);
  }

  return null;
};

/**
 *
 * @description Guard function to redirect to default page if user already loggedin
 *
 * @param {*} param
 */
const unProtectedPageLoaded = ({ request = {} }) => {
  const cookiesList = document.cookie.split(';');
  console.log(cookiesList);
  let applicationCookie = null ;
  for(let i = 0; i < cookiesList.length; i++) {
    let cookie = cookiesList[i];
    let item = cookie.split('=');
    if(item[0]==='auth_token'){
      applicationCookie = item[1] ;
    }
  } 
 

  if (applicationCookie) {
    return redirect('/dashboard');
  }
  return null;
};

export const roleGuard = {
  protectedLoader,
  adminProtectedLoader,
  customerProtectedLoader,
  unProtectedPageLoaded,
};
